import Swiper, { Pagination, Navigation, EffectFade, Autoplay, Controller } from 'swiper';

export default function swiper() {

    /*
    * HOMEPAGE
    */
    const screenWidth = window.matchMedia('(max-width:992px)'); 
    let swiperMetiers = null;

    function initSwiperMetiers() {
        const isMobile = window.innerWidth < 992;

        if (isMobile && !swiperMetiers && document.querySelector('.metiers-slider')) {
            swiperMetiers = new Swiper('.metiers-slider', {
                modules: [Pagination],
                slidesPerView: 2,
                spaceBetween: 16,
                grabCursor: true,
                pagination: {
                    el: '.swiper-pagination-metiers',
                    clickable: true,
                },
            });
        } else if (!isMobile && swiperMetiers) {
            swiperMetiers.destroy(true, true);
            swiperMetiers = null;
        }
    }

    window.addEventListener('load', initSwiperMetiers);
    window.addEventListener('resize', () => {
        setTimeout(initSwiperMetiers, 100);
    });
    
    // Activités
    const swiperActivites = new Swiper('.activites-slider', {
        modules: [Navigation],
        spaceBetween: 20,
        loop: false,
        slidesPerView: 2,
        lazy: true,
        grabCursor: true,
        autoHeight: true,
        navigation: {
            nextEl: ".swiper-button-next-activites",
            prevEl: ".swiper-button-prev-activites",
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
            },
        },
    });

    // Références
    const swiperFormations = new Swiper('.formations-slider', {
        modules: [Pagination, Navigation],
        loop: true,
        slidesPerView: 1,
        lazy: true,
        grabCursor: true,
        autoHeight: true,
        navigation: {
            nextEl: ".swiper-button-next-formations",
            prevEl: ".swiper-button-prev-formations",
        },
    });

    /*
    * BUILDER
    */

    const swiperLogo = new Swiper('.m-logos__loop', {
        modules: [Autoplay],
        loop: true,
        loopAdditionalSlides: 50,
        loopedSlidesLimit: false,
        loopPreventsSliding: false,

        slidesPerView: 'auto',
        centeredSlides: false,
        allowTouchMove: false,

        spaceBetween: 15,
        speed: 3000,
        autoplay: { 
            delay: 1, 
            disableOnInteraction: false 
            },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        breakpoints: { 
            1024: { 
                spaceBetween: 8 
            } 
        },
    });

    // Slider vidéos
    const swiperSliderVideos = new Swiper('.slider-videos', {
        modules: [Navigation],
        spaceBetween: 20,
        loop: false,
        slidesPerView: 1,
        lazy: true,
        grabCursor: true,
        autoHeight: true,
        navigation: {
            nextEl: ".swiper-button-next-slider-videos",
            prevEl: ".swiper-button-prev-slider-videos",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
        },
    });

    // Boucle
    const swiperBoucle = new Swiper('.boucle-slider', {
        modules: [Pagination],
        spaceBetween: 20,
        loop: false,
        slidesPerView: 1,
        lazy: true,
        grabCursor: true,
        // autoHeight: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 4,
            },
        },
    });

    // Boucle V2 carousel
    const swiperBoucleCarousel = new Swiper('.m-boucle-v2__carousel', {
        modules: [Pagination],
        spaceBetween: 20,
        loop: false,
        slidesPerView: 1,
        lazy: true,
        grabCursor: true,
        autoHeight: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 4,
            },
        },
    });

    // Slider Box
    const swiperSliderbox = new Swiper('.slider-box-slider', {
        modules: [Pagination, Navigation],
        loop: true,
        slidesPerView: 1,
        lazy: true,
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination-slider-box",
            clickable: true,
            renderBullet: function (index, className) {
                var titre_valeur = document.getElementsByClassName('valeur-titre');
                return '<span class="' + className + '">' + titre_valeur[index].textContent + "</span>";
            },
        },
        navigation: {
            nextEl: ".swiper-button-next-slider-box",
            prevEl: ".swiper-button-prev-slider-box",
        },
    });

    // Slider + Texte
    const swiperSliderTexte = new Swiper('.m-slider-texte-js', {
        modules: [Navigation],
        loop: true,
        slidesPerView: 1,
        lazy: true,
        effect: 'fade',
        speed: 600,
        grabCursor: true,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next-slider-texte",
            prevEl: ".swiper-button-prev-slider-texte",
        },
    });

    // Collaborateurs
    const swiperCollaborateurs = new Swiper('.m-collaborateurs-js', {
        modules: [Navigation],
        loop: true,
        slidesPerView: 1,
        lazy: true,
        effect: 'fade',
        speed: 600,
        grabCursor: true,
        spaceBetween: 20,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next-collaborateurs",
            prevEl: ".swiper-button-prev-collaborateurs",
        },
    });
}